import { isRejectedWithValue } from "@reduxjs/toolkit";
import { Filter } from "entities/orders";
import { getExcelOrders } from "entities/orders/model/ordersThunk";
import { DownloadNotification } from "features/filterManager/ui/downloadNotification";
import { useRef, useState } from "react"
import { toast } from "react-toastify";
import { getRandomUUID } from "shared/lib/core";
import { usePaginationFilter } from "shared/lib/pagination";
import { useAppDispatch } from "shared/lib/store";

export const useExcel = () => {
  const dispatch = useAppDispatch();

  const idempotencyKey = useRef<string>(crypto?.randomUUID ? crypto.randomUUID() : getRandomUUID());
  const successToastId = useRef<number | string>(0);
  const filters = usePaginationFilter()?.filters as unknown as Filter;
  const [ isLoading, setIsLoading ] = useState<boolean>(false)


  const onDownloadClick = (file: string) => {
    if (!file?.trim?.()) return;

    let name = 'Выгрузка бронирований';

    if (filters.dt_start__gte&&filters.dt_end__lte) {
      const opts = {
        day:'2-digit',
        month:'2-digit',
        year:'2-digit',
        hour:'2-digit',
        minute:'2-digit',
        timeZone: 'UTC',
      } as Intl.DateTimeFormatOptions

      const start = new Date(filters.dt_start__gte).toLocaleDateString('ru-RU', opts);
      const end = new Date(filters.dt_end__lte).toLocaleDateString('ru-RU', opts);

      name += ` за ${start} - ${end}`
    }

    const link = document.createElement('a');
    link.setAttribute('href', file);
    link.setAttribute('download', name);
    
    document.body.append(link);
    link.click();
    link.remove();
  }

  const handleFormation = async (toastId?: string|number, timeoutId?:NodeJS.Timeout) => {
    const payload = {
      ...filters,
      idempotencyKey: idempotencyKey.current
    }
    const result = await dispatch(getExcelOrders(payload))

    if (isRejectedWithValue(result)) {
      if (toastId) {
        toast.dismiss(toastId)
      }

      toast.error('Не удалось сформировать файл. Попробуйте ещё раз')
      setIsLoading(false);
      return;
    }

    clearTimeout(timeoutId);

    const resultPayload = result.payload;
    const status = resultPayload.status;
    
    if (status === 'PENDING') {
      timeoutId = setTimeout(() => {
        handleFormation(toastId, timeoutId);
      }, 1000);

      return;
    }

    if (status === 'COLLECTED') {
      if (toastId) {
        toast.dismiss(toastId)
      }

      const file = resultPayload.file;

      if (!file) {
        return toast.error('Файл сформирован, но по какой-то причине ссылка на него недоступна. Попробуйте ещё раз');
      }

      successToastId.current = toast.success(DownloadNotification, {
        pauseOnHover: true,
        autoClose: false,
        closeButton: false,
        data: {
          onClick: () => onDownloadClick(file)
        }
      })

      idempotencyKey.current = crypto?.randomUUID ? crypto.randomUUID() : getRandomUUID();

      setIsLoading(false);
    }
  }
  
  const onClick = () => {
    setIsLoading(true);

    if (successToastId.current) {
      toast.dismiss(successToastId.current);
    }

    const toastId = toast.info(
      'Файл формируется. Это может занять некоторое время',
      { autoClose: false },
    );

    handleFormation(toastId)
  }

  return {
    onClick,
    isLoading
  }
}